import {
    ChipField,
    Datagrid,
    List,
    ListProps,
    Pagination,
    ReferenceArrayField,
    SingleFieldList,
    TextField,
    useGetIdentity,
} from 'react-admin';

export const ClientList = (props: ListProps) => {
    const { identity } = useGetIdentity();
    return identity ? (
        <List
            {...props}
            bulkActionButtons={false}
            exporter={false}
            pagination={<Pagination rowsPerPageOptions={[]} />}
            perPage={25}
            sort={{ field: 'id', order: 'desc' }}
        >
            <Datagrid rowClick="show">
                <TextField source="id" label="ID" sortable={false} />
                <TextField source="name" label="名前" sortable={false} />
                <ReferenceArrayField source="clientWorkIdTypeIds" label="発注元工事 ID 種別" reference="clientWorkIdTypes" sortable={false}>
                    <SingleFieldList>
                        <ChipField source="name" size="small" variant="outlined" />
                    </SingleFieldList>
                </ReferenceArrayField>
            </Datagrid>
        </List>
    ) : null;
};
